export default __webpack_public_path__ + "static/media/dislike.ed5117f3.svg";